import React, { useRef, useState, useEffect } from 'react'
import { CuiMealCardsModal } from 'front-lib'
import Carrousel from 'src/componentsV2/Carrousel/Carrousel'
import { Navigation } from 'swiper/modules'
import { isAddOn } from '../../modules/MyPlan/utils'
import { CondensedMealCard } from '../MenuMealCard/CondensedMealCard/CondensedMealCard'
import { CondensedBundleCard } from '../MenuBundleCard/CondensedBundleCard/CondensedBundleCard'
import { RegularMealCard } from '../MenuMealCard/RegularMealCard/RegularMealCard'
import { RegularBundleCard } from 'src/componentsV2/MenuBundleCard/RegularBundleCard/RegularBundleCard'
import { useIsMobile } from 'src/hooks/useIsMobile'
import { isBundle } from 'src/common/MealMenu/utils'
import { trackMenuMealsModalArrowButtonClicked } from 'src/utils/tracking'
import { ReactComponent as ChevronLeft } from 'src/assets/icons/chevron-left.svg'
import { ReactComponent as ChevronRigth } from 'src/assets/icons/chevron-right.svg'
import classNames from 'classnames'
import './MenuMealCardsModal.scss'

const MenuMealCardsModal = props => {
  const IMG_URL_SOURCE = process.env.REACT_APP_IMG_URL_SOURCE
  const SLIDES_PER_VIEW = 3
  const {
    meals,
    onAddItem,
    onRemoveItem,
    onClickMeal,
    productCategory,
    crossSellingModal,
    disableMealsActions = false
  } = props
  const [isPrevDisabled, setIsPrevDisabled] = useState(true)
  const [isNextDisabled, setIsNextDisabled] = useState(false)
  const carrouselRef = useRef(null)
  const isMobile = useIsMobile()

  const onSlidePrev = () => {
    if (carrouselRef.current?.swiper && !isPrevDisabled) {
      carrouselRef.current.swiper.slidePrev()
      checkControls(carrouselRef.current.swiper)
      trackMenuMealsModalArrowButtonClicked({
        productCategory: productCategory,
        action: 'left arrow',
        modalName: crossSellingModal ? 'Cross Selling' : 'Free premium meals'
      })
    }
  }
  const onSlideNext = () => {
    if (carrouselRef.current?.swiper && !isNextDisabled) {
      carrouselRef.current.swiper.slideNext()
      checkControls(carrouselRef.current.swiper)
      trackMenuMealsModalArrowButtonClicked({
        productCategory: productCategory,
        action: 'right arrow',
        modalName: crossSellingModal ? 'Cross Selling' : 'Free premium meals'
      })
    }
  }

  const checkControls = swiper => {
    if (swiper) {
      setIsPrevDisabled(swiper.isBeginning)
      setIsNextDisabled(swiper.isBeginning ? false : swiper.isEnd)
    }
  }

  useEffect(() => {
    checkControls(carrouselRef?.current?.swiper)
  }, [carrouselRef])

  const settings = {
    spaceBetween: 20,
    slidesPerView: 'auto',
    resistance: false,
    navigation: true,
    onSlideChange: checkControls,
    onAfterInit: checkControls,
    watchSlidesProgress: true,
    modules: [Navigation]
  }

  return (
    <CuiMealCardsModal {...props}>
      {isMobile ? (
        <>
          {meals.map((meal, index) => (
            <div key={meal.id}>
              {isBundle(meal) ? (
                <CondensedBundleCard
                  bundle={meal}
                  isEditable={true}
                  stock={meal.stock}
                  quantity={meal.quantity || 0}
                  onBundleClick={() => onClickMeal(meal)}
                  onAddItem={onAddItem}
                  onRemoveItem={onRemoveItem}
                />
              ) : (
                <CondensedMealCard
                  key={meal.id}
                  index={index}
                  meal={{
                    ...meal,
                    magentoId: meal.magento_id,
                    full_path_meal_image: meal.imageUrl,
                    full_path_chef_image: `${IMG_URL_SOURCE}${meal.bannerpic}`,
                    protein_type: meal.meat_type,
                    short_description: meal.short_description || '',
                    premium_special: meal.premium_special || null,
                    secondary_image:
                      (meal.media && meal.media.secondaryImage) || null
                  }}
                  quantity={meal.quantity || 0}
                  onAddItem={onAddItem}
                  onRemoveItem={onRemoveItem}
                  onMealClick={() => onClickMeal(meal)}
                  isSelected={!!meal.quantity}
                  isEditable
                  isExtra={isAddOn(meal)}
                  onChefClick={() => {}}
                />
              )}
            </div>
          ))}
        </>
      ) : (
        <>
          <div
            className={classNames(
              'cards-modal-navigation-btn cards-modal-navigation-btn-left',
              {
                disabled: isPrevDisabled,
                hidden: meals.length <= SLIDES_PER_VIEW
              }
            )}
            onClick={onSlidePrev}>
            <ChevronLeft />
          </div>
          <Carrousel
            name="menu-tabs"
            carrouselRef={carrouselRef}
            settings={settings}>
            {meals.map((meal, index) => (
              <div className={'menuCardWrapper'} key={meal.id}>
                {isBundle(meal) ? (
                  <RegularBundleCard
                    bundle={meal}
                    isEditable={true}
                    stock={meal.stock}
                    quantity={meal.quantity || 0}
                    onBundleClick={() => onClickMeal(meal)}
                    onAddItem={onAddItem}
                    onRemoveItem={onRemoveItem}
                  />
                ) : (
                  <RegularMealCard
                    key={meal.id}
                    index={index}
                    meal={{
                      ...meal,
                      magentoId: meal.magento_id,
                      full_path_meal_image: meal.imageUrl,
                      full_path_chef_image: `${IMG_URL_SOURCE}${meal.bannerpic}`,
                      protein_type: meal.meat_type,
                      short_description: meal.short_description || '',
                      premium_special: meal.premium_special || null,
                      secondary_image:
                        (meal.media && meal.media.secondaryImage) || null
                    }}
                    quantity={meal.quantity || 0}
                    onAddItem={onAddItem}
                    onRemoveItem={onRemoveItem}
                    onMealClick={() => onClickMeal(meal)}
                    isSelected={!!meal.quantity}
                    isEditable
                    isExtra={isAddOn(meal)}
                    onChefClick={() => {}}
                    disableMealsActions={disableMealsActions}
                  />
                )}
              </div>
            ))}
          </Carrousel>
          <div
            className={classNames(
              'cards-modal-navigation-btn cards-modal-navigation-btn-right',
              {
                disabled: isNextDisabled,
                hidden: meals.length <= SLIDES_PER_VIEW
              }
            )}
            onClick={onSlideNext}>
            <ChevronRigth />
          </div>
        </>
      )}
    </CuiMealCardsModal>
  )
}

export { MenuMealCardsModal }
